import React from 'react'
import ReactDOM from 'react-dom'
import './assets/sass/root.scss'

import { Provider } from 'react-redux'
import store from './redux/store'
import Root from './root'

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root')
)
